module.exports = __webpack_public_path__ + "static/media/Canada.0ea1bc19.png";